import { ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  updated: string;
  children: ReactNode;
};

export const LegalLayout = ({ title, updated, children }: Props) => {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} — Pórtico`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
  <div className="min-h-screen bg-background text-foreground">
    <header className="border-b border-border/40">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-6 md:px-10">
        <Link to="/" className="flex items-baseline gap-2 font-display text-xl font-semibold tracking-tight">
          <img src="/logo.svg" alt="" className="h-6 w-6" />
          <span>Pórtico</span>
        </Link>
        <Link to="/" className="font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground">
          ← Voltar
        </Link>
      </div>
    </header>

    <article className="mx-auto max-w-3xl px-6 py-16 md:px-10 md:py-24">
      <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-muted-foreground">
        Atualizado em {updated}
      </p>
      <h1 className="mt-4 font-display text-4xl font-light tracking-tight md:text-5xl">{title}</h1>
      <div className="prose prose-neutral mt-10 max-w-none space-y-6 text-base leading-relaxed text-foreground/85 [&_h2]:mt-12 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:text-foreground [&_h3]:mt-6 [&_h3]:font-display [&_h3]:text-lg [&_h3]:text-foreground [&_a]:text-primary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:leading-relaxed">
        {children}
      </div>
    </article>

    <footer className="border-t border-border/40">
      <div className="mx-auto max-w-3xl px-6 py-10 text-xs text-muted-foreground md:px-10">
        <p>
          Pórtico · <Link to="/termos" className="hover:text-foreground">Termos</Link> ·{' '}
          <Link to="/privacidade" className="hover:text-foreground">Privacidade</Link> ·{' '}
          <Link to="/licenca-de-imagem" className="hover:text-foreground">Licença de Imagem</Link> ·{' '}
          <Link to="/suporte" className="hover:text-foreground">Suporte</Link>
        </p>
      </div>
    </footer>
  </div>
  );
};
